import StarIcon from "../../../images/icons/starIcon";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import ImageComponent from "../../components/shared/ImageComponent";
import NoProfile from "../../../images/profileImage.png";
import {Link} from "react-router-dom";
import {useChatRoom} from "../../../hooks/useChat";
import Crown from "../../../images/whiteCrown.svg";
import {useEffect, useState} from "react";
import ZipCodeIcon from "../../../images/icons/zipCode";
import {getDateLocale} from "../../../utils/date";
import {useTranslation} from "react-i18next";

const PrestataireCard = ({prestataire}) => {
  const {t} = useTranslation();
  const {onStartDirectChat} = useChatRoom();
  const [sectors, setSectors] = useState([]);
  useEffect(() => {
    const sectorMap = new Map();

    prestataire?.SubCategories?.forEach((element) => {
      const newSector = element?.Category?.Sector;

      if (newSector) {
        const {id, title, imagePath} = newSector;
        // Use the `id` as the key in the Map to ensure uniqueness
        sectorMap.set(id, {id, title, imagePath});
      }
    });

    // Convert the Map values to an array
    setSectors(Array.from(sectorMap.values()));
  }, [prestataire]);
  return (
    <div className="w-full p-6 flex flex-col gap-y-2 sm:flex-row sm:items-center justify-between items-start overflow-hidden relative bg-white rounded-2xl border border-solid border-[#E2E2E2] ">
      <div className="flex flex-col items-start gap-3">
        <div className="flex items-start justify-start gap-3 ">
          <Link
            to={`/prestataire/${prestataire?.id}`}
            className="relative min-w-11 w-11"
          >
            {!!prestataire.User?.avgRating && (
              <div className="bg-[#FFC107] w-[30px] flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[7px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] ">
                {Number(prestataire.User?.avgRating).toFixed(2)}
                <StarIcon className="fill-white stroke-none w-2 h-2" />
              </div>
            )}
            {!!prestataire?.taxRegistrationNumber && (
              <div className="absolute w-[14px] h-[14px] bg-[#1A64B9] flex justify-center items-center top-0 right-0 text-[#1A64B9] rounded-full">
                <img className="w-[10px]" src={Crown} alt="" />{" "}
              </div>
            )}
            <ImageComponent
              src={buildImageUrl(prestataire?.User?.imageUri)}
              alt=""
              className=" w-11 h-11 min-w-11 rounded-full object-cover"
              fallback={
                <img
                  src={NoProfile}
                  alt=""
                  className=" w-11 h-11 min-w-11 rounded-full object-cover"
                  width="130"
                />
              }
            />
          </Link>
          <div className="flex flex-col justify-center items-start">
            <Link
              to={`/prestataire/${prestataire?.id}`}
              className="text-[#19295C] font-bold text-base capitalize hover:underline"
            >
              {prestataire?.User?.lastName + " " + prestataire?.User?.firstName}
            </Link>
            <div className="flex items-center justify-start gap-2 flex-wrap ">
              <div className="text-dark text-[14px] text-nowrap ">
                <span className="text-[#FF6600] font-bold">
                  {" "}{t("provider")}{" "}
                </span>
              </div>
              <span className="text-[#7E7E7E] text-[12px]">
                {`(${t("memberSince")} ${new Date(prestataire?.createdAt).toLocaleDateString(
                  getDateLocale(),
                  {
                    year: "numeric", // année
                    month: "short",
                  },
                )})`}
              </span>
            </div>
          </div>
        </div>
        {!!sectors.length && (
          <div className="flex items-center justify-start flex-wrap gap-2">
            <div className="bg-[#F1F2F7] rounded-md   flex !px-[12px] !py-[5px] gap-2 justify-center items-center text-sm font-semibold text-[#19295C]">
              <ImageComponent
                src={buildImageUrl(sectors[0]?.imagePath)}
                alt="secteur"
                title={sectors[0]?.title}
                className=" w-4 aspect-square"
              />
              <span>{sectors[0]?.title}</span>
            </div>

            {sectors.length > 1 && (
              <div
                title={sectors.slice(1).map((el) => el.title)}
                className="bg-[#F1F2F7] rounded-md   flex !px-[12px] !py-[5px] gap-2 justify-center items-center text-sm font-semibold text-[#19295C]"
              >
                {`+${sectors.length - 1}`}
              </div>
            )}
          </div>
        )}
        {!!prestataire?.InterventionAreas?.length && (
          <div className="flex justify-start flex-wrap items-center gap-2">
            {prestataire?.InterventionAreas?.map((zone) => (
              <div
                key={zone?.id}
                className="flex justify-start !rounded-full items-center gap-2  px-2 py-1 bg-[#D5E3F3] text-[#1A64B9] font-bold text-sm"
              >
                <ZipCodeIcon className="w-4 h-4 fill-[#1A64B9]" /> {zone?.code}
                {/* 75000 */}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="flex   sm:flex-col items-end justify-center gap-2 w-full sm:w-auto">
        <Link className="w-full " to={`/prestataire/${prestataire?.id}`}>
          <button className="font-bold px-[10px] py-[8px]  sm:px-[20px] sm:py-[13px] text-xs min-w-[100px] w-full  !rounded-lg bg-white !text-[#0D44B1] !border-[#0D44B1] !border  border-solid ">
            {t("viewProfile")}
          </button>
        </Link>
        <button
          onClick={() => {
            onStartDirectChat({technicianId: prestataire?.id});
          }}
          className="font-bold px-[10px] py-[8px]  sm:px-[20px] sm:py-[13px] text-xs min-w-[100px] w-full gap-1 !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white sw-btn-next"
        >
          {t("contact")}{" "}
          <span className="hidden sm:inline-block capitalize">
            {prestataire?.User?.firstName}
          </span>
        </button>
      </div>
    </div>
  );
};

export default PrestataireCard;
